import CompanyDisclaimer from 'src/Components/shared/CompanyDisclaimer'
import CompanyDisclaimerContainer from './CompanyDisclaimerContainer'

export default CompanyDisclaimerContainer(CompanyDisclaimer)
